import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';

import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

lessRequire('modules/shared/form-elements/attachments.less');

const AttachmentsField = props => {
	const { addFileToUpload, removeFileFromUpload, info, placeholder, files, maxSizeError, externalKey, intl } = props;

	return (
		<div className="form-element form-element__attachments">
			<label className="form-element__attachments-control">
				<span className="label font-proxima-nova-semibold">{placeholder}</span>
				<input
					key={externalKey || +new Date()}
					type="file"
					disabled={props.disabled}
					onChange={e => addFileToUpload(e.target.files[0])} />
			</label>
			<span className="info font-times-new-roman-ps">{info}</span>
			{ !isEmpty(files) && map(files, (file, i) => {
				return file ? (<p key={`file${i}`} className="filename">
					{file.name || ''}
					<span className="remove-attachment"
						title={intl('Удалить вложение')}
						onClick={e => {
							e.preventDefault();
							return removeFileFromUpload(i);
						}}
					/>
				</p>) : null;
			}) }

			{maxSizeError  && (<div className="has-error font-proxima-nova-regular">
				{intl('Общий размер загруженных файлов')}
				{intl('превышает лимит в 5МБ')}
			</div>)
			}
		</div>
	);
};

AttachmentsField.propTypes = {
	input: PropTypes.object,
	placeholder: PropTypes.string,
	info: PropTypes.string,
	disabled: PropTypes.bool,
	addFileToUpload: PropTypes.func,
	removeFileFromUpload: PropTypes.func,
	files: PropTypes.array,
	maxSizeError: PropTypes.bool,
	externalKey: PropTypes.number,
	intl: PropTypes.func
};

export default AttachmentsField;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/form-elements/attachments.js